import { gql } from '@apollo/client'

const ERRORS = `errors { path, message }`;

const FILE_UPLOAD_FIELDS = `
  id
  name
  fileUrl
`;


export const CREATE_FILE_UPLOAD = gql`
  mutation CreateFileUpload(
    $name: String!
    $ownerType: String!
    $ownerId: Int!
    $file: Upload!
  ) {
    createFileUpload(
      name: $name
      ownerType: $ownerType
      ownerId: $ownerId
      file: $file
    ) {
      fileUpload {
        ${FILE_UPLOAD_FIELDS}
      }
    }
  }
`;

export const FILE_UPLOAD = gql`
  query FileUpload($id: ID!) {
    fileUpload(id: $id) {
      id
      fileUrl
      name
    }
  }
`;
